import React, { Component, Fragment } from "react";


import CustomerSetup from "./customerSetup.js";
import "../../assets/scss/pages/app-library.scss";

const mql = window.matchMedia(`(min-width: 992px)`)

class CustomersApp extends Component {
  state = {
    sidebarDocked: mql.matches,
    sidebarOpen: false
  }
  UNSAFE_componentWillMount() {
    mql.addListener(this.mediaQueryChanged)
  }

  componentWillUnmount() {
    mql.removeListener(this.mediaQueryChanged)
  }

  onSetSidebarOpen = open => {
    this.setState({ sidebarOpen: open })
  }

  mediaQueryChanged = () => {
    this.setState({ sidebarDocked: mql.matches, sidebarOpen: false })
  }
  render() {
    return (
      <CustomerSetup
        sidebarOpen={this.state.sidebarOpen}
        sidebarDocked={this.state.sidebarDocked}
        onSetSidebarOpen={(value) => this.onSetSidebarOpen(value)}
        hasAddNewFunctionality={true}
      />
    )
  }
}


export default CustomersApp;
